






















































































































import { createComponent, computed, ref, Ref } from '@vue/composition-api';
import { crossEnv } from '@sbvr/lbe-environment';
import { storeUserSetup, lookupUserSetup } from '@/core/actions';
import UIInput from '@sbvr/lbe-ui/UIInput.vue';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import UICheckbox from '@sbvr/lbe-ui/UICheckbox.vue';
import store from '@/core/store';
import router from '@/core/routes';
import i18n from '@/core/i18n';
import { useObjectWithChangeDetection, useLoading } from '@sbvr/lbe-composition-helpers';
import useFlashService from '@sbvr/lbe-web-panel/flash';

interface User {
  id: string;
  name: string;
  email: string;
  agreedAt: string;
  password: string;
  confirmPassword: string;
  systemEmails: boolean;
  agreeTOS: boolean;
}
export default createComponent({
  name: 'InvitedAuthRoute',
  components: {
    UIInput,
    UIButton,
    UICheckbox,
  },
  props: {
    userId: {
      type: String,
    },
  },
  setup (props) {
    function useVerifyKey () {
      const invalidKey = ref(true);
      const { loading, subscribeToPromise } = useLoading();
      const promise = (async function () {
        await new Promise(resolve => router.onReady(resolve));
        const { validationKey } = router.currentRoute.query;
        if (typeof validationKey === 'string') {
          try {
            const user = await lookupUserSetup(validationKey);
            store.dispatch('insertEntities', { name: 'User', payload: user });
            invalidKey.value = false;
            router.push({ name: 'verify', params: { userId: user.id }, query: { validationKey } });
          } catch (error) {
            invalidKey.value = true;
          }
        }
      })();
      subscribeToPromise(promise);
      return {
        loading,
        invalidKey,
      };
    }
    const userInStore = computed(() => store.getters['entities/User'](props.userId));
    const {
      object: user,
    } = useObjectWithChangeDetection(userInStore as Ref<User>);
    const validationKey = computed(() => {
      if (typeof router.currentRoute.query.validationKey === 'string') {
        return router.currentRoute.query.validationKey;
      }
    });
    const valid = computed(() => {
      return user.value.name && user.value.password?.length >= 8 && user.value.password === user.value.confirmPassword && user.value.agreeTOS;
    });
    const operatorUrl = crossEnv.OPERATOR_URL;
    const publicUrl = crossEnv.PUBLIC_URL;

    async function onSubmit (e) {
      e.preventDefault();
      if (!validationKey.value) return;
      try {
        const storedUser = await storeUserSetup(
          {
            id: user.value.id,
            name: user.value.name,
            password: user.value.password,
            passwordConfirmation: user.value.confirmPassword,
            systemEmails: user.value.systemEmails,
          },
          validationKey.value,
        );
        store.dispatch('insertEntities', { name: 'User', payload: storedUser });
      } catch (error) {
        const { showFlash } = useFlashService();
        showFlash({
          type: 'error',
          render (h) {
            return h('i18n', {
              props: {
                path: 'Something went wrong. Try again or contact {link}',
              },
            }, [h(UIButton, {
              slot: 'link',
              props: {
                link: true,
              },
              attrs: {
                href: 'mailto:support@springboardvr.com',
              },
            },
            'support@springboardvr.com',
            )]);
          },
        });
      }
    };

    return {
      ...useVerifyKey(),
      user,
      onSubmit,
      valid,
      operatorUrl,
      publicUrl,
    };
  },
});
